import Post from 'src/components/post/Post';
import { formatDate } from '@itdeptutahcountygovernment/date-formatting';

const NoPostsMessage = () => {
  const noPost = {
    id: 'no-posts',
    title: 'No Posts Yet...',
    content: 'Check back later for more updates',
    createdAt: formatDate(new Date()),
    attachments: [],
    className: '',
  };

  return <Post {...noPost} onEditClick={() => {}} onDeleteClick={() => {}} />;
};

export default NoPostsMessage;
